var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropMenuSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 4.31667C1.33333 5.10556 1.59722 5.78333 2.125 6.35C2.65278 6.91667 3.31111 7.23333 4.1 7.3L3.06667 6.26667L4 5.33333L6.66667 8L4 10.6667L3.06667 9.73333L4.13333 8.66667C2.96667 8.6 1.98611 8.15 1.19167 7.31667C0.397222 6.48333 0 5.48889 0 4.33333C0 3.12222 0.419444 2.09722 1.25833 1.25833C2.09722 0.419445 3.12222 0 4.33333 0H6.66667V1.33333H4.33333C3.5 1.33333 2.79167 1.62222 2.20833 2.2C1.625 2.77778 1.33333 3.48333 1.33333 4.31667ZM8 8.66667V7.33333H13.3333V8.66667H8ZM8 5V3.66667H13.3333V5H8ZM8 1.33333V0H13.3333V1.33333H8Z",
    fill: "#007587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropMenuSelected);
export default __webpack_public_path__ + "static/media/dropMenuSelected.4f580421d326f09c2ba5b4748bd1f0de.svg";
export { ForwardRef as ReactComponent };